import React from 'react';
import { DentalSchedulingDashboardWithProvider } from '../../basicOrganizationApplications/components/DentalSchedulingDashboard';
import { AppNameMap, EntityNameMap } from '../../../../../shared/utils/engagementAnalyticsTransformers';
import PlatformDashboardShell from './PlatformDashboardShell';
import { PlatformOrganizationItemModel } from './PlatformOrganizationItem';

interface PlatformSchedulingDashboardContentProps {
    organizations: PlatformOrganizationItemModel[];
    appNameMap: AppNameMap;
    entityNameMap: EntityNameMap;
    representativeAppId?: string;
    platformAppIdsByOrganizationId: Record<string, string[]>;
    selectedAppLiveStatusMap?: Record<string, boolean>;
    hasOutboundCallApps: boolean;
    isLoading: boolean;
}

const PlatformSchedulingDashboardContent: React.FC<PlatformSchedulingDashboardContentProps> = (props) => {
    return (
        <PlatformDashboardShell
            title="Platform Scheduling"
            variant="scheduling"
            organizations={props.organizations}
            appNameMap={props.appNameMap}
            selectedAppLiveStatusMap={props.selectedAppLiveStatusMap}
            entityNameMap={props.entityNameMap}
            representativeAppId={props.representativeAppId}
            platformAppIdsByOrganizationId={props.platformAppIdsByOrganizationId}
            isOutboundCallApp={props.hasOutboundCallApps}
            isLoading={props.isLoading}
            DashboardComponent={DentalSchedulingDashboardWithProvider}
        />
    );
};

export default PlatformSchedulingDashboardContent;
